// removed by extract-text-webpack-plugin
module.exports = {"root":"_1I1Wt","starRating":"_3yoIm","starRatingCount":"_2jw0T"};